var _path, _path2, _path3, _path4, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 206,
    viewBox: "0 0 206 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2338_1647)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.676 99.4419C154.681 98.9886 154.547 98.5448 154.293 98.1691L126.842 58.3883C126.635 58.0874 126.357 57.8416 126.033 57.672C125.709 57.5025 125.349 57.4143 124.983 57.4152L76.6506 57.5204C76.1981 57.5265 75.7578 57.6688 75.3874 57.9288L104.107 99.5527L154.676 99.4419Z",
    fill: "url(#paint0_linear_2338_1647)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.107 99.5527L79.0512 147.416C79.3749 147.586 79.7351 147.674 80.1006 147.673L128.433 147.568C128.843 147.567 129.245 147.454 129.596 147.241C129.947 147.028 130.232 146.724 130.422 146.361L154.436 100.492C154.602 100.167 154.683 99.8064 154.676 99.4419L104.107 99.5527Z",
    fill: "url(#paint1_linear_2338_1647)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3874 57.9288C75.0843 58.1323 74.8358 58.4062 74.6622 58.7274L50.6483 104.596C50.458 104.959 50.3706 105.368 50.3954 105.777C50.4203 106.186 50.5564 106.581 50.7892 106.919L78.2404 146.7C78.448 147 78.7273 147.247 79.0512 147.416L104.107 99.5527L75.3874 57.9288Z",
    fill: "url(#paint2_linear_2338_1647)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.647 99.7024L78.6659 143.6L52.5258 105.72L52.5266 105.72C52.5121 105.699 52.5038 105.675 52.5022 105.649C52.5007 105.624 52.5058 105.598 52.5176 105.576L75.4615 61.7507L101.647 99.7024ZM128.552 145.382C128.54 145.404 128.523 145.424 128.501 145.437C128.49 145.444 128.478 145.449 128.466 145.452L128.429 145.458L82.4051 145.557L105.386 101.66L151.495 101.559L128.552 145.382ZM125.054 59.5416C125.074 59.5522 125.092 59.5679 125.104 59.5867L125.105 59.5871L151.156 97.3384L105.213 97.4394L79.1219 59.6249L124.988 59.5255L124.989 59.526C125.011 59.5259 125.034 59.531 125.054 59.5416Z",
    stroke: "url(#paint3_linear_2338_1647)",
    strokeOpacity: 0.1,
    strokeWidth: 4.2208
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 23.8294,
    y: -3.13224,
    width: 194.905,
    height: 139.179
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(18.99px)",
      clipPath: "url(#bgblur_1_2338_1647_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2338_1647)",
    "data-figma-bg-blur-radius": 37.9867
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.748 97.8936C180.754 97.2137 180.553 96.548 180.173 95.9845L138.997 36.3141C138.686 35.8627 138.269 35.4939 137.784 35.2396C137.298 34.9853 136.757 34.8531 136.209 34.8545L63.711 35.0125C63.0322 35.0215 62.3719 35.235 61.8162 35.6251L104.895 98.0601L180.748 97.8936Z",
    fill: "url(#paint4_linear_2338_1647)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.343 36.0805C137.692 36.2633 137.991 36.5289 138.215 36.8533L179.388 96.5188C179.479 96.6535 179.555 96.7968 179.616 96.9454L105.393 97.1086L63.2409 36.0179C63.3988 35.9836 63.5609 35.9645 63.7241 35.9623L63.7237 35.961L136.211 35.8043C136.606 35.8033 136.994 35.8978 137.343 36.0805Z",
    stroke: "url(#paint5_linear_2338_1647)",
    strokeOpacity: 0.1,
    strokeWidth: 1.89934
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 29.322,
    y: 59.9056,
    width: 189.414,
    height: 148.32
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(18.99px)",
      clipPath: "url(#bgblur_2_2338_1647_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2338_1647)",
    "data-figma-bg-blur-radius": 37.9867
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.895 98.0588L67.3087 169.853C67.7943 170.107 68.3346 170.24 68.8828 170.239L141.381 170.081C141.996 170.079 142.599 169.91 143.125 169.59C143.651 169.271 144.079 168.814 144.364 168.27L180.385 99.4668C180.634 98.9798 180.758 98.439 180.748 97.8923L104.895 98.0588Z",
    fill: "url(#paint6_linear_2338_1647)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.625 98.8441C179.599 98.9087 179.571 98.9728 179.539 99.0351L143.523 167.829C143.318 168.221 143.01 168.55 142.632 168.779C142.302 168.98 141.928 169.098 141.544 169.125L141.379 169.131L68.8804 169.289C68.8134 169.289 68.7466 169.285 68.6801 169.28L105.471 99.0068L179.625 98.8441Z",
    stroke: "url(#paint7_linear_2338_1647)",
    strokeOpacity: 0.1,
    strokeWidth: 1.89934
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -13.6651,
    y: -2.36418,
    width: 156.547,
    height: 210.203
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(18.99px)",
      clipPath: "url(#bgblur_3_2338_1647_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_2338_1647)",
    "data-figma-bg-blur-radius": 37.9867
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8164 35.6226C61.3617 35.9279 60.9881 36.3392 60.7278 36.8211L24.7072 105.624C24.4218 106.169 24.2906 106.781 24.3279 107.395C24.3651 108.009 24.5694 108.601 24.9186 109.108L66.0944 168.778C66.4059 169.229 66.8225 169.598 67.3083 169.852L104.895 98.0576L61.8164 35.6226Z",
    fill: "url(#paint8_linear_2338_1647)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.788 98.1246L66.9981 168.397C66.9869 168.383 66.9747 168.371 66.9639 168.357L66.8761 168.238L25.7 108.568L25.7008 108.568C25.4499 108.204 25.3028 107.779 25.2761 107.337C25.2493 106.896 25.3429 106.456 25.5479 106.064L61.563 37.2723C61.597 37.2093 61.635 37.1487 61.6743 37.0892L103.788 98.1246Z",
    stroke: "url(#paint9_linear_2338_1647)",
    strokeOpacity: 0.1,
    strokeWidth: 1.89934
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2338_1647",
    x: 23.8294,
    y: -3.13224,
    width: 194.905,
    height: 139.179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.33112
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2338_1647"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_2338_1647_clip_path",
    transform: "translate(-23.8294 3.13224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.748 97.8936C180.754 97.2137 180.553 96.548 180.173 95.9845L138.997 36.3141C138.686 35.8627 138.269 35.4939 137.784 35.2396C137.298 34.9853 136.757 34.8531 136.209 34.8545L63.711 35.0125C63.0322 35.0215 62.3719 35.235 61.8162 35.6251L104.895 98.0601L180.748 97.8936Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2338_1647",
    x: 29.322,
    y: 59.9056,
    width: 189.414,
    height: 148.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.33112
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2338_1647"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_2338_1647_clip_path",
    transform: "translate(-29.322 -59.9056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.895 98.0588L67.3087 169.853C67.7943 170.107 68.3346 170.24 68.8828 170.239L141.381 170.081C141.996 170.079 142.599 169.91 143.125 169.59C143.651 169.271 144.079 168.814 144.364 168.27L180.385 99.4668C180.634 98.9798 180.758 98.439 180.748 97.8923L104.895 98.0588Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_2338_1647",
    x: -13.6651,
    y: -2.36418,
    width: 156.547,
    height: 210.203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.33112
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2338_1647"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_2338_1647_clip_path",
    transform: "translate(13.6651 2.36418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8164 35.6226C61.3617 35.9279 60.9881 36.3392 60.7278 36.8211L24.7072 105.624C24.4218 106.169 24.2906 106.781 24.3279 107.395C24.3651 108.009 24.5694 108.601 24.9186 109.108L66.0944 168.778C66.4059 169.229 66.8225 169.598 67.3083 169.852L104.895 98.0576L61.8164 35.6226Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2338_1647",
    x1: 86.1471,
    y1: 36.7903,
    x2: 170.081,
    y2: 108.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2338_1647",
    x1: 86.1471,
    y1: 36.7903,
    x2: 170.081,
    y2: 108.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2338_1647",
    x1: 86.1471,
    y1: 36.7903,
    x2: 170.081,
    y2: 108.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2338_1647",
    x1: 86.5044,
    y1: 42.1747,
    x2: 163.786,
    y2: 82.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769231,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2338_1647",
    x1: 78.3171,
    y1: 4.10681,
    x2: 168.968,
    y2: 125.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#85A0FF",
    stopOpacity: 0.13
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2338_1647",
    x1: 80.5388,
    y1: 8.90809,
    x2: 195.755,
    y2: 69.2279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769231,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2338_1647",
    x1: 121.282,
    y1: 66.7595,
    x2: 189.043,
    y2: 116.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83E9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#85A0FF",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2338_1647",
    x1: 120.698,
    y1: 72.4244,
    x2: 178.657,
    y2: 102.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769231,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2338_1647",
    x1: 61.4545,
    y1: 35.4331,
    x2: 129.216,
    y2: 84.6935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#85A0FF",
    stopOpacity: 0.31
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2338_1647",
    x1: 60.8707,
    y1: 41.0981,
    x2: 118.829,
    y2: 71.4416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769231,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2338_1647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 151.947,
    height: 151.947,
    fill: "white",
    transform: "translate(70.4755) rotate(27.6336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.43253cd45887b08bc3f31e048cafe35c.svg";
export { ForwardRef as ReactComponent };